export const MexStates = {
	AGU: 'Aguascalientes',
	BCN: 'Baja California',
	BCS: 'Baja California Sur',
	CAM: 'Campeche',
	CHH: 'Chihuahua',
	CHP: 'Chiapas',
	CMX: 'Ciudad de México',
	COA: 'Coahuila',
	COL: 'Colima',
	DUR: 'Durango',
	GRO: 'Guerrero',
	GUA: 'Guanajuato',
	HID: 'Hidalgo',
	JAL: 'Jalisco',
	MEX: 'Estado de México',
	MIC: 'Michoacán',
	MOR: 'Morelos',
	NAY: 'Nayarit',
	NLE: 'Nuevo León',
	OAX: 'Oaxaca',
	PUE: 'Puebla',
	QUE: 'Querétaro',
	ROO: 'Quintana Roo',
	SIN: 'Sinaloa',
	SLP: 'San Luis Potosí',
	SON: 'Sonora',
	TAB: 'Tabasco',
	TAM: 'Tamaulipas',
	TLA: 'Tlaxcala',
	VER: 'Veracruz',
	YUC: 'Yucatán',
	ZAC: 'Zacatecas'
};

export const Nationalities = {
	MEXICAN: 'Mexicana'
};

export const CountryCodes = {
	ABW: 'Aruba',
	AFG: 'Afghanistan',
	AGO: 'Angola',
	AIA: 'Anguilla',
	ALA: 'Åland Islands',
	ALB: 'Albania',
	AND: 'Andorra',
	ANT: 'Netherlands Antilles',
	ARE: 'United Arab Emirates',
	ARG: 'Argentina',
	ARM: 'Armenia',
	ASM: 'American Samoa',
	ATA: 'Antarctica',
	ATF: 'French Southern Territories',
	ATG: 'Antigua and Barbuda',
	AUS: 'Australia',
	AUT: 'Austria',
	AZE: 'Azerbaijan',
	BDI: 'Burundi',
	BEL: 'Belgium',
	BEN: 'Benin',
	BES: 'Bonaire, Sint Eustatius and Saba',
	BFA: 'Burkina Faso',
	BGD: 'Bangladesh',
	BGR: 'Bulgaria',
	BHR: 'Bahrain',
	BHS: 'Bahamas',
	BIH: 'Bosnia and Herzegovina',
	BLM: 'Saint Barthélemy',
	BLR: 'Belarus',
	BLZ: 'Belize',
	BMU: 'Bermuda',
	BOL: 'Bolivia',
	BRA: 'Brazil',
	BRB: 'Barbados',
	BRN: 'Brunei Darussalam',
	BTN: 'Bhutan',
	BVT: 'Bouvet Island',
	BWA: 'Botswana',
	CAF: 'Central African Republic',
	CAN: 'Canada',
	CCK: 'Cocos (Keeling) Islands',
	CHE: 'Switzerland',
	CHL: 'Chile',
	CHN: 'China',
	CIV: "Côte d'Ivoire",
	CMR: 'Cameroon',
	COD: 'Congo, Democratic Republic of the',
	COG: 'Congo',
	COK: 'Cook Islands',
	COL: 'Colombia',
	COM: 'Comoros',
	CPV: 'Cabo Verde',
	CRI: 'Costa Rica',
	CUB: 'Cuba',
	CUW: 'Curaçao',
	CXR: 'Christmas Island',
	CYM: 'Cayman Islands',
	CYP: 'Cyprus',
	CZE: 'Czechia',
	DEU: 'Germany',
	DJI: 'Djibouti',
	DMA: 'Dominica',
	DNK: 'Denmark',
	DOM: 'Dominican Republic',
	DZA: 'Algeria',
	ECU: 'Ecuador',
	EGY: 'Egypt',
	ERI: 'Eritrea',
	ESH: 'Western Sahara',
	ESP: 'Spain',
	EST: 'Estonia',
	ETH: 'Ethiopia',
	FIN: 'Finland',
	FJI: 'Fiji',
	FLK: 'Falkland Islands (Malvinas)',
	FRA: 'France',
	FRO: 'Faroe Islands',
	FSM: 'Micronesia (Federated States of)',
	GAB: 'Gabon',
	GBR: 'United Kingdom',
	GEO: 'Georgia',
	GGY: 'Guernsey',
	GHA: 'Ghana',
	GIB: 'Gibraltar',
	GIN: 'Guinea',
	GLP: 'Guadeloupe',
	GMB: 'Gambia',
	GNB: 'Guinea-Bissau',
	GNQ: 'Equatorial Guinea',
	GRC: 'Greece',
	GRD: 'Grenada',
	GRL: 'Greenland',
	GTM: 'Guatemala',
	GUF: 'French Guiana',
	GUM: 'Guam',
	GUY: 'Guyana',
	HKG: 'Hong Kong',
	HMD: 'Heard Island and McDonald Islands',
	HND: 'Honduras',
	HRV: 'Croatia',
	HTI: 'Haiti',
	HUN: 'Hungary',
	IDN: 'Indonesia',
	IMN: 'Isle of Man',
	IND: 'India',
	IOT: 'British Indian Ocean Territory',
	IRL: 'Ireland',
	IRN: 'Iran (Islamic Republic of)',
	IRQ: 'Iraq',
	ISL: 'Iceland',
	ISR: 'Israel',
	ITA: 'Italy',
	JAM: 'Jamaica',
	JEY: 'Jersey',
	JOR: 'Jordan',
	JPN: 'Japan',
	KAZ: 'Kazakhstan',
	KEN: 'Kenya',
	KGZ: 'Kyrgyzstan',
	KHM: 'Cambodia',
	KIR: 'Kiribati',
	KNA: 'Saint Kitts and Nevis',
	KOR: 'Korea (Republic of)',
	KWT: 'Kuwait',
	LAO: "Lao People's Democratic Republic",
	LBN: 'Lebanon',
	LBR: 'Liberia',
	LBY: 'Libya',
	LCA: 'Saint Lucia',
	LIE: 'Liechtenstein',
	LKA: 'Sri Lanka',
	LSO: 'Lesotho',
	LTU: 'Lithuania',
	LUX: 'Luxembourg',
	LVA: 'Latvia',
	MAC: 'Macao',
	MAF: 'Saint Martin (French part)',
	MAR: 'Morocco',
	MCO: 'Monaco',
	MDA: 'Moldova (Republic of)',
	MDG: 'Madagascar',
	MDV: 'Maldives',
	MEX: 'Mexico',
	MHL: 'Marshall Islands',
	MKD: 'North Macedonia',
	MLI: 'Mali',
	MLT: 'Malta',
	MMR: 'Myanmar',
	MNE: 'Montenegro',
	MNG: 'Mongolia',
	MNP: 'Northern Mariana Islands',
	MOZ: 'Mozambique',
	MRT: 'Mauritania',
	MSR: 'Montserrat',
	MTQ: 'Martinique',
	MUS: 'Mauritius',
	MWI: 'Malawi',
	MYS: 'Malaysia',
	MYT: 'Mayotte',
	NAM: 'Namibia',
	NCL: 'New Caledonia',
	NER: 'Niger',
	NFK: 'Norfolk Island',
	NGA: 'Nigeria',
	NIC: 'Nicaragua',
	NIU: 'Niue',
	NLD: 'Netherlands',
	NOR: 'Norway',
	NPL: 'Nepal',
	NRU: 'Nauru',
	NZL: 'New Zealand',
	OMN: 'Oman',
	PAK: 'Pakistan',
	PAN: 'Panama',
	PCN: 'Pitcairn',
	PER: 'Peru',
	PHL: 'Philippines',
	PLW: 'Palau',
	PNG: 'Papua New Guinea',
	POL: 'Poland',
	PRI: 'Puerto Rico',
	PRK: "Korea (Democratic People's Republic of)",
	PRT: 'Portugal',
	PRY: 'Paraguay',
	PSE: 'Palestine, State of',
	PYF: 'French Polynesia',
	QAT: 'Qatar',
	REU: 'Réunion',
	ROU: 'Romania',
	RUS: 'Russian Federation',
	RWA: 'Rwanda',
	SAU: 'Saudi Arabia',
	SDN: 'Sudan',
	SEN: 'Senegal',
	SGP: 'Singapore',
	SGS: 'South Georgia and the South Sandwich Islands',
	SHN: 'Saint Helena, Ascension and Tristan da Cunha',
	SJM: 'Svalbard and Jan Mayen',
	SLB: 'Solomon Islands',
	SLE: 'Sierra Leone',
	SLV: 'El Salvador',
	SMR: 'San Marino',
	SOM: 'Somalia',
	SPM: 'Saint Pierre and Miquelon',
	SRB: 'Serbia',
	SSD: 'South Sudan',
	STP: 'Sao Tome and Principe',
	SUR: 'Suriname',
	SVK: 'Slovakia',
	SVN: 'Slovenia',
	SWE: 'Sweden',
	SWZ: 'Eswatini',
	SXM: 'Sint Maarten (Dutch part)',
	SYC: 'Seychelles',
	SYR: 'Syrian Arab Republic',
	TCA: 'Turks and Caicos Islands',
	TCD: 'Chad',
	TGO: 'Togo',
	THA: 'Thailand',
	TJK: 'Tajikistan',
	TKL: 'Tokelau',
	TKM: 'Turkmenistan',
	TLS: 'Timor-Leste',
	TON: 'Tonga',
	TTO: 'Trinidad and Tobago',
	TUN: 'Tunisia',
	TUR: 'Turkey',
	TUV: 'Tuvalu',
	TWN: 'Taiwan, Province of China',
	TZA: 'Tanzania, United Republic of',
	UGA: 'Uganda',
	UKR: 'Ukraine',
	UMI: 'United States Minor Outlying Islands',
	URY: 'Uruguay',
	USA: 'United States of America',
	UZB: 'Uzbekistan',
	VAT: 'Holy See',
	VCT: 'Saint Vincent and the Grenadines',
	VEN: 'Venezuela (Bolivarian Republic of)',
	VGB: 'Virgin Islands (British)',
	VIR: 'Virgin Islands (U.S.)',
	VNM: 'Viet Nam',
	VUT: 'Vanuatu',
	WLF: 'Wallis and Futuna',
	WSM: 'Samoa',
	YEM: 'Yemen',
	ZAF: 'South Africa',
	ZMB: 'Zambia',
	ZWE: 'Zimbabwe'
};

export const CountryCodesES = {
	ABW: 'Aruba',
	AFG: 'Afganistán',
	AGO: 'Angola',
	AIA: 'Anguila',
	ALA: 'Islas Åland',
	ALB: 'Albania',
	AND: 'Andorra',
	ANT: 'Antillas Neerlandesas',
	ARE: 'Emiratos Árabes Unidos',
	ARG: 'Argentina',
	ARM: 'Armenia',
	ASM: 'Samoa Americana',
	ATA: 'Antártida',
	ATF: 'Territorios Australes Franceses',
	ATG: 'Antigua y Barbuda',
	AUS: 'Australia',
	AUT: 'Austria',
	AZE: 'Azerbaiyán',
	BDI: 'Burundi',
	BEL: 'Bélgica',
	BEN: 'Benín',
	BES: 'Bonaire, San Eustaquio y Saba',
	BFA: 'Burkina Faso',
	BGD: 'Bangladés',
	BGR: 'Bulgaria',
	BHR: 'Baréin',
	BHS: 'Bahamas',
	BIH: 'Bosnia y Herzegovina',
	BLM: 'San Bartolomé',
	BLR: 'Bielorrusia',
	BLZ: 'Belice',
	BMU: 'Bermudas',
	BOL: 'Bolivia',
	BRA: 'Brasil',
	BRB: 'Barbados',
	BRN: 'Brunéi Darussalam',
	BTN: 'Bután',
	BVT: 'Isla Bouvet',
	BWA: 'Botsuana',
	CAF: 'República Centroafricana',
	CAN: 'Canadá',
	CCK: 'Islas Cocos (Keeling)',
	CHE: 'Suiza',
	CHL: 'Chile',
	CHN: 'China',
	CIV: 'Costa de Marfil',
	CMR: 'Camerún',
	COD: 'República Democrática del Congo',
	COG: 'Congo',
	COK: 'Islas Cook',
	COL: 'Colombia',
	COM: 'Comoras',
	CPV: 'Cabo Verde',
	CRI: 'Costa Rica',
	CUB: 'Cuba',
	CUW: 'Curazao',
	CXR: 'Isla de Navidad',
	CYM: 'Islas Caimán',
	CYP: 'Chipre',
	CZE: 'Chequia',
	DEU: 'Alemania',
	DJI: 'Yibuti',
	DMA: 'Dominica',
	DNK: 'Dinamarca',
	DOM: 'República Dominicana',
	DZA: 'Argelia',
	ECU: 'Ecuador',
	EGY: 'Egipto',
	ERI: 'Eritrea',
	ESH: 'Sahara Occidental',
	ESP: 'España',
	EST: 'Estonia',
	ETH: 'Etiopía',
	FIN: 'Finlandia',
	FJI: 'Fiyi',
	FLK: 'Islas Malvinas',
	FRA: 'Francia',
	FRO: 'Islas Feroe',
	FSM: 'Micronesia (Estados Federados de)',
	GAB: 'Gabón',
	GBR: 'Reino Unido',
	GEO: 'Georgia',
	GGY: 'Guernsey',
	GHA: 'Ghana',
	GIB: 'Gibraltar',
	GIN: 'Guinea',
	GLP: 'Guadalupe',
	GMB: 'Gambia',
	GNB: 'Guinea-Bisáu',
	GNQ: 'Guinea Ecuatorial',
	GRC: 'Grecia',
	GRD: 'Granada',
	GRL: 'Groenlandia',
	GTM: 'Guatemala',
	GUF: 'Guayana Francesa',
	GUM: 'Guam',
	GUY: 'Guyana',
	HKG: 'Hong Kong',
	HMD: 'Islas Heard y McDonald',
	HND: 'Honduras',
	HRV: 'Croacia',
	HTI: 'Haití',
	HUN: 'Hungría',
	IDN: 'Indonesia',
	IMN: 'Isla de Man',
	IND: 'India',
	IOT: 'Territorio Británico del Océano Índico',
	IRL: 'Irlanda',
	IRN: 'Irán (República Islámica de)',
	IRQ: 'Iraq',
	ISL: 'Islandia',
	ISR: 'Israel',
	ITA: 'Italia',
	JAM: 'Jamaica',
	JEY: 'Jersey',
	JOR: 'Jordania',
	JPN: 'Japón',
	KAZ: 'Kazajistán',
	KEN: 'Kenia',
	KGZ: 'Kirguistán',
	KHM: 'Camboya',
	KIR: 'Kiribati',
	KNA: 'San Cristóbal y Nieves',
	KOR: 'Corea (República de)',
	KWT: 'Kuwait',
	LAO: 'República Democrática Popular Lao',
	LBN: 'Líbano',
	LBR: 'Liberia',
	LBY: 'Libia',
	LCA: 'Santa Lucía',
	LIE: 'Liechtenstein',
	LKA: 'Sri Lanka',
	LSO: 'Lesoto',
	LTU: 'Lituania',
	LUX: 'Luxemburgo',
	LVA: 'Letonia',
	MAC: 'Macao',
	MAF: 'San Martín (parte francesa)',
	MAR: 'Marruecos',
	MCO: 'Mónaco',
	MDA: 'Moldavia (República de)',
	MDG: 'Madagascar',
	MDV: 'Maldivas',
	MEX: 'México',
	MHL: 'Islas Marshall',
	MKD: 'Macedonia del Norte',
	MLI: 'Malí',
	MLT: 'Malta',
	MMR: 'Myanmar',
	MNE: 'Montenegro',
	MNG: 'Mongolia',
	MNP: 'Islas Marianas del Norte',
	MOZ: 'Mozambique',
	MRT: 'Mauritania',
	MSR: 'Montserrat',
	MTQ: 'Martinica',
	MUS: 'Mauricio',
	MWI: 'Malaui',
	MYS: 'Malasia',
	MYT: 'Mayotte',
	NAM: 'Namibia',
	NCL: 'Nueva Caledonia',
	NER: 'Níger',
	NFK: 'Isla Norfolk',
	NGA: 'Nigeria',
	NIC: 'Nicaragua',
	NIU: 'Niue',
	NLD: 'Países Bajos',
	NOR: 'Noruega',
	NPL: 'Nepal',
	NRU: 'Nauru',
	NZL: 'Nueva Zelanda',
	OMN: 'Omán',
	PAK: 'Pakistán',
	PAN: 'Panamá',
	PCN: 'Islas Pitcairn',
	PER: 'Perú',
	PHL: 'Filipinas',
	PLW: 'Palaos',
	PNG: 'Papúa Nueva Guinea',
	POL: 'Polonia',
	PRI: 'Puerto Rico',
	PRK: 'Corea (República Popular Democrática de)',
	PRT: 'Portugal',
	PRY: 'Paraguay',
	PSE: 'Palestina, Estado de',
	PYF: 'Polinesia Francesa',
	QAT: 'Catar',
	REU: 'Reunión',
	ROU: 'Rumania',
	RUS: 'Federación de Rusia',
	RWA: 'Ruanda',
	SAU: 'Arabia Saudita',
	SDN: 'Sudán',
	SEN: 'Senegal',
	SGP: 'Singapur',
	SGS: 'Islas Georgias del Sur y Sandwich del Sur',
	SHN: 'Santa Elena, Ascensión y Tristán de Acuña',
	SJM: 'Svalbard y Jan Mayen',
	SLB: 'Islas Salomón',
	SLE: 'Sierra Leona',
	SLV: 'El Salvador',
	SMR: 'San Marino',
	SOM: 'Somalia',
	SPM: 'San Pedro y Miquelón',
	SRB: 'Serbia',
	SSD: 'Sudán del Sur',
	STP: 'Santo Tomé y Príncipe',
	SUR: 'Surinam',
	SVK: 'Eslovaquia',
	SVN: 'Eslovenia',
	SWE: 'Suecia',
	SWZ: 'Esuatini',
	SXM: 'Sint Maarten (parte neerlandesa)',
	SYC: 'Seychelles',
	SYR: 'República Árabe Siria',
	TCA: 'Islas Turcas y Caicos',
	TCD: 'Chad',
	TGO: 'Togo',
	THA: 'Tailandia',
	TJK: 'Tayikistán',
	TKL: 'Tokelau',
	TKM: 'Turkmenistán',
	TLS: 'Timor-Leste',
	TON: 'Tonga',
	TTO: 'Trinidad y Tobago',
	TUN: 'Túnez',
	TUR: 'Turquía',
	TUV: 'Tuvalu',
	TWN: 'Taiwán, Provincia de China',
	TZA: 'Tanzania, República Unida de',
	UGA: 'Uganda',
	UKR: 'Ucrania',
	UMI: 'Islas Ultramarinas Menores de Estados Unidos',
	URY: 'Uruguay',
	USA: 'Estados Unidos de América',
	UZB: 'Uzbekistán',
	VAT: 'Santa Sede',
	VCT: 'San Vicente y las Granadinas',
	VEN: 'Venezuela (República Bolivariana de)',
	VGB: 'Islas Vírgenes (Británicas)',
	VIR: 'Islas Vírgenes (EE.UU.)',
	VNM: 'Vietnam',
	VUT: 'Vanuatu',
	WLF: 'Wallis y Futuna',
	WSM: 'Samoa',
	YEM: 'Yemen',
	ZAF: 'Sudáfrica',
	ZMB: 'Zambia',
	ZWE: 'Zimbabue'
};

export const Occupations = {
	GOVERNMENT_EMPLOYEE: 'GovernmentEmployee',
	OTHER: 'Other',
	PRIVATE_SECTOR: 'PrivateSector',
	STUDENT: 'Student'
};
